import t from "./withMetadataArgument.mjs";
import e from "./getExampleNumber2.mjs";
function a() {
  return t(e, arguments);
}
export {
  a as getExampleNumber
};
//# sourceMappingURL=getExampleNumber.mjs.map
